module.exports = __webpack_public_path__ + "media/audio123.5e506403.mp3";